export var createMuiTableOverrides = function (_a) {
    var palette = _a.palette, shape = _a.shape;
    return ({
        root: {
            backgroundColor: palette.background.paper,
            borderRadius: shape.borderRadius,
        },
    });
};
//# sourceMappingURL=MuiTable.js.map